import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from '../http.service';
import { Observable } from 'rxjs';
import { AdminPaymentMethod, UpdatePaymentMethodPayload } from '../../../models/admin/payment-method.model';
import { SubmitResponse } from '../../../models/common/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodService extends HttpService<UpdatePaymentMethodPayload, AdminPaymentMethod> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'payment-methods');
  }

  /**
   * List all payment methods.
   *
   * Each row carries `commission` (DECIMAL(10,2) — may arrive as a string) and
   * `commission_type`. Rows created before the commission-type migration omit
   * `commission_type`; run it through `toCommissionType()` before use.
   */
  getPaymentMethods(): Observable<AdminPaymentMethod[]> {
    return this.getAll() as Observable<AdminPaymentMethod[]>;
  }

  /**
   * Update a payment method's commission — `PUT /api/v1/payment-methods/:id`.
   *
   * The server bounds `commission` at 100 only when `commission_type` is
   * `percentage`; fixed AED amounts are unbounded above 0.
   */
  updatePaymentMethod(id: number | string, payload: UpdatePaymentMethodPayload): Observable<SubmitResponse> {
    return this.update(payload, '', id);
  }
}
